import React, { useState, useEffect } from "react";
import * as prosConnect from "../prodect/ProsConnect"
import {getObsStateHistory, prosLogDt} from "./ProsConnect";
import {ATTR_OBJ_ID} from "./ProsConnect";
import {
    ObsStateHistoryItem, getItemTypeText,
    getUpdatedBy, getUpdatedTimeWithSecondsStr, getCreatedBy, getCreatedTimeStr
} from './ProsCommonUi';
import Spacer from "../components/Spacer";
import BasicButton from "../components/BasicButton";
import LoadingAnimation from "../components/LoadingAnimation";

export default function ProsObsHistoryListing({obs, selectedObsHistoryObjId, renderItemCallback}) {
    const [selectedObsHistoryList, setSelectedObsHistoryList] = useState(null)
    const obsId = obs[ATTR_OBJ_ID]
    
    useEffect(() => {
        if(selectedObsHistoryObjId === obsId){
            setSelectedObsHistoryList(null)
            const project = prosConnect.getActiveProject()
            prosLogDt("start loading history...")
            prosConnect.awaitLoadObjectHistory(project.getPid(), selectedObsHistoryObjId).then((obsHistory) => {
                const historyList = selectedObsHistoryObjId === obsId
                    ? obsHistory 
                    : null;
                setSelectedObsHistoryList(historyList);
                prosLogDt(" history loaded, length:", historyList.length);
            });
        }
    }, [obsId, selectedObsHistoryObjId]);

    if(selectedObsHistoryObjId === obsId){
        const obsStateHistory = getObsStateHistory(obs);
        return <div className={"list-view-item opened"}>
            <div className={"list-view-item-content"}>
                <h4>Tilamuutokset</h4>
                {renderObsStateHistory(obsStateHistory)}
                <Spacer size={"lg"}/>
                <ObsChangeHistory obs={obs} obsHistoryList={selectedObsHistoryList} renderItemCallback={renderItemCallback} />
            </div>
        </div>
    } 
    return null
}

function renderObsStateHistory(selectedObsHistoryList) {
    if (!selectedObsHistoryList) {
        return null
    }
    if (!selectedObsHistoryList.length) {
        return <p>Ei tilamuutoksia</p>
    }
    return <div className={"scrollpane-horizontal"}>
        <table>
            <tbody>
            {selectedObsHistoryList.slice().reverse().map((hist, i) =>
                (<ObsStateHistoryItem key={i} hist={hist} />)
            )}
            </tbody>
        </table>
    </div>
}

function ObsChangeHistory({obs, obsHistoryList, renderItemCallback, ...props}) {
    const [showAll, setShowAll] = useState(false)
    if(!obsHistoryList){
        return <LoadingAnimation text={"Muutoslokia ladataan..."}/>
    }
    if(obsHistoryList && obsHistoryList.length === 0){
        return <p> Ei muutoksia.</p>
    }
    const histItems = showAll ? obsHistoryList : [obsHistoryList[obsHistoryList.length - 1]]
    return <>
        <h4>Muutosloki{!showAll ? ' (viimeisin muutos)' : ''}</h4>
        {histItems.slice().reverse().map((histItem, index) => {
            let header = "";
            let byWhom = getUpdatedBy(histItem)
            let when = getUpdatedTimeWithSecondsStr(histItem, true)
            if (!(histItem.hasOwnProperty("attr_changes")) &&
                histItem[prosConnect.ATTR_OBJ_STATE] === prosConnect.OBJ_STATE_ACT) {
                header = "Lisätty " + getItemTypeText(histItem);
                byWhom = getCreatedBy(histItem)
                when = getCreatedTimeStr(histItem, true)
            } else if (histItem[prosConnect.ATTR_OBJ_STATE] === prosConnect.OBJ_STATE_TO_DEL ||
                histItem[prosConnect.ATTR_OBJ_STATE] === prosConnect.OBJ_STATE_DEL) {
                header = "Poistettu " + getItemTypeText(histItem);
            } else {
                header = "Muokattu " + getItemTypeText(histItem);
                if (histItem.attr_changes) {
                    const changes = histItem.attr_changes;
                    if (changes.length === 1 && changes[0].attr === 'obs_id') {
                        header = "Numeroinnin lisäys (" + getItemTypeText(histItem) + ")";
                    } else if (changes.length === 1 && changes[0].attr === 'text') {
                        header = "Tekstin muokkaus (" + getItemTypeText(histItem) + ")";
                    } else if (changes.length === 1 && changes[0].attr === prosConnect.ATTR_OBJ_STATE &&
                        (changes[0].prev_value === prosConnect.OBJ_STATE_TO_DEL || changes[0].prev_value === prosConnect.OBJ_STATE_DEL) &&
                        changes[0].new_value === prosConnect.OBJ_STATE_ACT) {
                        header = "Poistetun palautus (" + getItemTypeText(histItem) + ")";
                    }
                }
            }
            header += ", " + byWhom + ', ' + when
            // Add a couple of essential params to render obs correctly
            histItem.ui_isOpen = true;
            histItem.obsObjList = [];
            histItem.ui_isHistoryItem = true;
            return <div key={"hist__" + index} className={"history-item"}>
                <h6>{header}</h6>
                {histItem && renderItemCallback(histItem)}
                {renderUndoDeletedControl(histItem)}
            </div>
        })}
        {showAll ? null : <BasicButton
            btnClass={"2nd"}
            icon={"chevron-right"}
            label={"Kaikki muutokset"}
            action={setShowAll}
        />}
    </>
}

export function renderUndoDeletedControl(item, isDropdown) {
    if (!hasPermissionToRestoreContent()) {
        return isDropdown ? [] : null
    }
    if (!hasCapacityToRestoreContent(false)) {
        return isDropdown ? [] : null
    }
    // If undo done already at least once, we have history element for it, i.e. "-upd" suffix present in obj_id.
    // We filter these out - so you can only perform Undo for the latest delete of the same item.
    // Option: if we allow that in the future, for the same reason, need to make a copy so that history won't be affected
    if (item.ui_isHistoryItem &&
        (item[prosConnect.ATTR_OBJ_STATE] === prosConnect.OBJ_STATE_TO_DEL ||
        item[prosConnect.ATTR_OBJ_STATE] === prosConnect.OBJ_STATE_DEL) &&
        !item[prosConnect.ATTR_OBJ_ID].includes("-upd")){
        if(isDropdown) return {
            text: 'Palauta poistettu',
            icon: 'bin-undo',
            action: async ()=> {
                let newItem = JSON.parse(JSON.stringify(item))
                newItem[prosConnect.ATTR_OBJ_ID] = item[prosConnect.ATTR_OBJ_ID].split("-upd")[0]
                newItem[prosConnect.ATTR_OBJ_STATE] = prosConnect.OBJ_STATE_ACT
                await prosConnect.getActiveProject().awaitUpdateItem(newItem)
            }
        }
        return <BasicButton
            btnClass={"2nd"}
            label={"Palauta poistettu"}
            icon={"bin-undo"}
            action={async () => {
                let newItem = JSON.parse(JSON.stringify(item));
                newItem[prosConnect.ATTR_OBJ_ID] = item[prosConnect.ATTR_OBJ_ID].split("-upd")[0];
                newItem[prosConnect.ATTR_OBJ_STATE] = prosConnect.OBJ_STATE_ACT;
                await prosConnect.getActiveProject().awaitUpdateItem(newItem);
            }}
        />
    }
    return null
}

function hasPermissionToRestoreContent() {
    return prosConnect.hasPermissionTo("addContent", undefined, undefined, false);
}

function hasCapacityToRestoreContent(isObs) {
    return prosConnect.getActiveProject().hasCapacityToAddItems(isObs);
}

// This is used when debugging history
/*
function renderHistoryDump(obs, histItem){
    let debugHistoryElements;
    if (!prosConnect.isSuperUserModePossible()) {
        return null
    }
    prosLogDt("current object", obs);
    prosLogDt("history object", histItem);
    const getText = (text) => text || '';
    const histEditedItem = (ch, index) => {
        if(ch.new_label)
            return <p key={"hist"+index} style={{color: "gray"}}>{`${ch.prev_label}: ${getText(ch.prev_value)} -> ${ch.new_label}: ${getText(ch.new_value)}`}</p> 
        else if(ch.attr === 'obs_id'){
            return <p key={"hist"+index} style={{color: "gray"}}>{`${getText(ch.prev_value)} ${getText(histItem.text)} -> ${getText(ch.new_value)} ${getText(histItem.text)}`}</p>
        }
        else
            return <p key={"hist"+index} style={{color: "gray"}}>{`${ch.attr}: ${getText(ch.prev_value)} -> ${ch.attr}: ${ch.new_value}`}</p>
    }
    const relevantHistObj = Object.keys(histItem)
            .filter(attrName => !prosConnect.ATTRS_NOT_FOR_HISTORY_LISTING.includes(attrName))
            .reduce((total, attrName) => {
                total[attrName] = histItem[attrName]
                return total;
            }, {});

    if (relevantHistObj.attr_changes){
        const changes = relevantHistObj.attr_changes.filter(ch => ch.attr !== 'rep_ind');
        debugHistoryElements = <div style={{color: "gray"}}>{changes.map((ch, index) => {
            if(ch.action === 'add'){
                return histEditedItem(ch, index);
            } else if(ch.action === 'remove'){
                return histEditedItem(ch, index);
            } else { //(ch.action === 'change')
                return histEditedItem(ch, index);
            }
        })}<p style={{color: "gray"}}>{JSON.stringify(relevantHistObj, null, 4)}</p></div>
    } else {
        debugHistoryElements = JSON.stringify(relevantHistObj, null, 4);
    }
    return <div style={{color: "gray"}}>{debugHistoryElements}</div>;
}
*/

